import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform
{

  public transform(value: string, limit = 25, completeWords = false, ellipsis = '...'): string
  {
    if (value != null) {
      if (value.length < limit)
      {
        return `${value.substring(0, limit)}`;
      }

      if (completeWords)
      {
        limit = value.substring(0, limit).lastIndexOf(' ');
      }
      return `${value.substring(0, limit)}${ellipsis}`;
    }
  }

}
